//20180525 sample 提携企業データ
export const getPartnersData = () => {
	return new Promise((resolve) => {
		let xhr = new XMLHttpRequest()
		xhr.onreadystatechange = () => {
			if(xhr.readyState === 4 && xhr.status === 200) {
				resolve(xhr.response)
			}
		}
		xhr.open('GET','/api/partners')
		xhr.setRequestHeader('Content-Type','application/json')
		xhr.setRequestHeader('Accept','application/json')
		xhr.send()
	}).then((partners) => {
		return partners
	})
}



// WEBPACK FOOTER //
// ./src/datas/partners.js